<script>
import { createNamespacedHelpers } from 'vuex';

import { FETCH_COACH } from '@/store/coach/types';
import { ROUTE_COURSE_CREATE_DATE_SELECTOR, ROUTE_COURSE_CREATE_CONTENT } from '@/router/names';
import datetimeUtils from '@/utils/datetime';
import mixinDraft from './draft.mixin';

const { mapState: mapCoachState, mapActions: mapCoachActions } = createNamespacedHelpers('coach');

export default {
    async created() {
        if (!this.coach) {
            await this.fetchCoach();
        }
        this.initializeDraft();

        if (!this.coach.course_time_publicly) {
            this.fillDraft({
                date: datetimeUtils.getFirstDay(true),
                undetermined: true,
            });
            this.$router.replace({
                name: ROUTE_COURSE_CREATE_CONTENT,
            });
        } else {
            this.$router.replace({
                name: ROUTE_COURSE_CREATE_DATE_SELECTOR,
            });
        }
    },
    computed: {
        ...mapCoachState({
            coach: state => state.coach,
        }),
    },
    methods: {
        ...mapCoachActions({
            fetchCoach: FETCH_COACH,
        }),
    },
    render() {
        return null;
    },
    mixins: [
        mixinDraft,
    ],
};
</script>



// WEBPACK FOOTER //
// src/components/course/Create.vue